import {
  InnerContentItem,
  OuterContentItem,
  PrimaryTag,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

export function CredentialsSummaryField({
  field,
}: {
  field: components["schemas"]["CredentialsCheckField"];
}) {
  const { t } = useTranslation();

  return (
    <>
      {field.value.length === 0 && (
        <InnerContentItem
          textStyle="global/body-secondary"
          textColor="text-weak"
        >
          <Trans>None provided</Trans>
        </InnerContentItem>
      )}

      {field.value.map((credential, index) => (
        <OuterContentItem
          title={`${credential.certification}`}
          subtitle={credential.institution}
          key={credential.id}
          tag={
            credential.highest_level ? (
              <PrimaryTag type="subtle">
                <Trans>Highest level</Trans>
              </PrimaryTag>
            ) : (
              credential.current && (
                <PrimaryTag type="subtle">
                  <Trans>In progress</Trans>
                </PrimaryTag>
              )
            )
          }
          testID={`credentials-summary-credential-${index + 1}`}
        >
          <InnerContentItem
            label={t("Institution")}
            testID={`credentials-summary-credential-${index + 1}-institution`}
          >
            {credential.institution}
          </InnerContentItem>
          <InnerContentItem
            label={t("Credential title")}
            testID={`credentials-summary-credential-${index + 1}-title`}
          >
            {credential.certification}
          </InnerContentItem>
          <InnerContentItem
            label={t("Credential description")}
            testID={`credentials-summary-credential-${index + 1}-description`}
          >
            {credential.description || "-"}
          </InnerContentItem>
          {credential.date_of_certification ? (
            <InnerContentItem
              label={t("Date received")}
              testID={`credentials-summary-credential-${index + 1}-date`}
            >
              {formatDate(credential.date_of_certification, "MMMM yyyy")}
            </InnerContentItem>
          ) : (
            <InnerContentItem
              label={t("Date received")}
              testID={`credentials-summary-credential-${index + 1}-in-progress`}
            >
              <Trans>In progress</Trans>
            </InnerContentItem>
          )}

          {field.require_highest_level && (
            <InnerContentItem
              label={t("Highest level of credential")}
              testID={`credentials-summary-credential-${
                index + 1
              }-highest-level`}
            >
              {credential.highest_level ? (
                <Trans>Yes</Trans>
              ) : (
                <Trans>No</Trans>
              )}
            </InnerContentItem>
          )}
        </OuterContentItem>
      ))}
    </>
  );
}
